export default "__VITE_ASSET__2d6873b5__"